import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';
import { RecipeLite } from '@shared/models/recipe/recipe-lite.model';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { ApplianceGroup, DataRefsByKey, MarketingFood, Unit, Utensil } from '@shared/models/dataref.model';
import { RefDataService } from '@services/ref-data.service';

@Component({
  selector: 'app-variant-tab-body',
  templateUrl: './variant-tab-body.component.html',
  styleUrls: ['./variant-tab-body.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: {
        displayDefaultIndicatorType: false,
        showError: true,
      },
    },
  ],
  standalone: false,
})
export class VariantTabBodyComponent implements OnChanges {
  @Input() variant?: RecipeLite | null;
  @Input() formVariant?: UntypedFormGroup;
  @Input() yieldUnits?: DataRefsByKey<Unit> | null;
  @Input() marketingFoods: MarketingFood[] = [];
  @Input() applianceGroupsRefData?: DataRefsByKey<ApplianceGroup> | null;
  @Input() utensilsRefData?: DataRefsByKey<Utensil> | null;

  formArrayIngredients: UntypedFormArray = new UntypedFormArray([]);
  formArraySteps: UntypedFormArray = new UntypedFormArray([]);

  showAutoBtn = false;
  selectedStepIcon = 'dashboard_customize';

  constructor(private readonly refDataService: RefDataService) {}

  stepSelect(event: StepperSelectionEvent): void {
    this.selectedStepIcon = event.selectedStep.state;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.formVariant?.currentValue) {
      this.formArrayIngredients = changes.formVariant.currentValue.get('ingredients') as UntypedFormArray;
      this.formArraySteps = changes.formVariant.currentValue.get('steps') as UntypedFormArray;

      this.refDataService.getFeatureFlags('AUTOMATIC_VARIANTS_ACTIVATION').subscribe((autoVariantsAllowed) => {
        this.showAutoBtn = autoVariantsAllowed.activatedAreas.some(
          (area) =>
            area.domain.key === this.variant?.domain && area.market.key === this.variant?.market && area.lang.key === this.variant?.lang,
        );
      });
    }
  }
}
